import { DeactivatedBadge } from "@/components/badges/DeactivatedBadge";

type StructureNameCellProps = {
	name: string;
	isActive: boolean;
};

export const StructureNameCell = ({ name, isActive }: StructureNameCellProps) => {
	if (isActive) return <>{name}</>;

	return (
		<span className="inline-flex items-center gap-2">
			{name}
			<DeactivatedBadge />
		</span>
	);
};
